import { render, staticRenderFns } from "./OrkSocial.html?vue&type=template&id=1f7f737e&"
import script from "./OrkSocial.vue?vue&type=script&lang=js&"
export * from "./OrkSocial.vue?vue&type=script&lang=js&"
import style0 from "./OrkSocial.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports